import {extendConfig} from './extend-config';

export const config = extendConfig({
  datadog: {
    enabled: true,
    environment: `stg`,
    enableDebugLogging: true,
  },
  groundcover: {
    sessionSampleRate: 100,
  },
});
